<app-invoicing-nav [activeMenuItem]="'invoices'"></app-invoicing-nav>


<mat-card class="content-card">



  <div *ngIf="currentUserIsAdmin()" style="margin-bottom: 20px;">
    <form *ngIf="templateForm" [formGroup]="templateForm" (ngSubmit)="onSubmitFilterStats(templateForm)">
      <div style="width: 100%;">
        <div fxFlex="15">
          <app-date-edit formControlName="startFilterDate" placeholder="Start Date"></app-date-edit>
        </div>
        <div fxFlex="2"></div>
        <div fxFlex="15">
          <app-date-edit formControlName="endFilterDate" placeholder="End Date"></app-date-edit>
        </div>
        <div fxFlex="2"></div>
        <div fxFlex="13">
          <mat-form-field>
            <mat-label>Brand</mat-label>
            <mat-select formControlName="companyId">
              <mat-option *ngFor="let company of companies" [value]="company.id" [ngStyle]="{'color': (company.archived) ? 'red' : 'black'}" >{{company.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="15">
          <mat-form-field>
            <mat-label>Product</mat-label>
            <mat-select formControlName="productIds" multiple>
              <mat-option *ngFor="let product of productsToShow" [value]="product.id">{{product.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="20">
          <button style="margin-top: 10px;" mat-raised-button color="primary">Filter</button>
        </div>
      </div>

      <div *ngIf="isStatsLoading">
        <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
      </div>
      <div style="width: 100%;" *ngIf="annualFeeStats && !isStatsLoading">
        <div fxFlex="10">
          <div class="sts-box" style="text-align: center; border: 1px solid grey;">
            Total<br />
            {{ annualFeeStats.totalAnnualFees | number: '1.2-2' }}
          </div>
        </div>
        <div fxFlex="10">
          <div class="sts-box" style="text-align: center; border: 1px solid grey;">
            Reminded<br />
            {{ annualFeeStats.remindedAnnualFees | number: '1.2-2' }}
          </div>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            Paid to CC<br />
            {{ annualFeeStats.paidToCardCompactAnnualFees | number: '1.2-2' }}
          </div>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            Paid to Pair<br />
            {{ annualFeeStats.paidToPairFinanceAnnualFees | number: '1.2-2' }}
          </div>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            Paid to Culpa<br />
            {{ annualFeeStats.paidToCulpaAnnualFees | number: '1.2-2' }}
          </div>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            Paid to CB<br />
            {{ annualFeeStats.paidToCashBroAnnualFees | number: '1.2-2' }}
          </div>
        </div>


        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            Total paid<br />
            {{ annualFeeStats.totalPaid | number: '1.2-2' }}
          </div>
        </div>


        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            % Total<br />
            {{ annualFeeStats.paidToCardCompactTotalPercent | number: '1.2-2' }}%
          </div>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            % CC<br />
            {{ annualFeeStats.paidToCardCompactToRemindedPercent | number: '1.2-2' }}%<br />
          </div>
          <small>Not in collection</small>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            % Pair<br />
            {{ annualFeeStats.paidToPairFinanceToRemindedPercent | number: '1.2-2' }}%
          </div>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            % Culpa<br />
            {{ annualFeeStats.paidToCulpaToRemindedPercent | number: '1.2-2' }}%
          </div>
        </div>

        <div fxFlex="10">
          <div  class="sts-box" style="text-align: center; border: 1px solid grey;">
            % CB<br />
            {{ annualFeeStats.paidToCashBroToRemindedPercent | number: '1.2-2' }}%
          </div>
        </div>
      </div>

    </form>
  </div>

  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <a mat-raised-button color="primary" *ngIf="currentUserIsAdmin()" (click)="uploadPayments()">Upload payments</a>
    <a mat-raised-button color="primary" *ngIf="currentUserIsAdmin() || currentUserIsPartner()" (click)="openPaymentReport()">Invoices report - annual fees</a>
    <div fxFlex></div>
  </mat-card-header>

  <div fxLayout="row wrap" fxLayoutGap="10px">
    <div fxLayout="column">
      <mat-button-toggle-group>
        <mat-button-toggle #allButton [checked]="table && table.filters && (table.filters.someAdditionalData == '' || table.filters.someAdditionalData == null)" class="mat-b-toggle-thin" (click)="filterInvoicesByProvenience(0)"><label class="label-for-mat-toggle-button">All</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'from_assistant'" class="mat-b-toggle-thin" (click)="filterInvoicesByProvenience(1)"><label class="label-for-mat-toggle-button">Individual</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'from_import'" *ngIf="currentUserIsAdmin()"class="mat-b-toggle-thin" (click)="filterInvoicesByProvenience(2)"><label class="label-for-mat-toggle-button">Bulk</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'voucher_orders'" *ngIf="currentUserIsAdmin()"class="mat-b-toggle-thin" (click)="filterInvoicesByProvenience(3)"><label class="label-for-mat-toggle-button">Vouchers</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'cancellations'" class="mat-b-toggle-thin" (click)="filterInvoicesByProvenience(4)"><label class="label-for-mat-toggle-button">Cancellations</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'docs'" class="mat-b-toggle-thin" (click)="filterInvoicesByProvenience(5)"><label class="label-for-mat-toggle-button">Docs</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'annual_fee'" class="mat-b-toggle-thin" [hidden]="!currentUserIsManager() && !currentUserIsAdmin()" (click)="filterInvoicesByProvenience(7)"><label class="label-for-mat-toggle-button">Annual fees</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'cash_bro'" class="mat-b-toggle-thin" [hidden]="!currentUserIsAdmin()" (click)="filterInvoicesByProvenience(6)"><label class="label-for-mat-toggle-button">CashBro</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'pair_finance'" class="mat-b-toggle-thin" [hidden]="!currentUserIsManager() && !currentUserIsAdmin()" (click)="filterInvoicesByProvenience(8)"><label class="label-for-mat-toggle-button">PairFinance</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'culpa'" class="mat-b-toggle-thin" [hidden]="!currentUserIsManager() && !currentUserIsAdmin()" (click)="filterInvoicesByProvenience(10)"><label class="label-for-mat-toggle-button">Culpa</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'troy'" class="mat-b-toggle-thin" [hidden]="!currentUserIsManager() && !currentUserIsAdmin()" (click)="filterInvoicesByProvenience(11)"><label class="label-for-mat-toggle-button">Troy</label></mat-button-toggle>
        <mat-button-toggle [checked]="table && table.filters && table.filters.someAdditionalData == 'pair_finance_failed'" class="mat-b-toggle-thin" [hidden]="!currentUserIsAdmin() && !currentUserIsCompliance()" (click)="filterInvoicesByProvenience(9)"><label class="label-for-mat-toggle-button">Distribution Failed</label></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <app-mat-table-generator #table
                           [saveFilters]=true
                           tableName="invoiceTable"
                           [useEmbededFilter]="true"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="deleteEnabled()"
                           [customActions]="invoiceCustomActions"
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           [defaultSortField] = "'creationDate'"
                           [defaultSortDirection]="'desc'"
                           (clearingFilters)="checkAllButton($event)">
  </app-mat-table-generator>
</mat-card>
